// @flow
export default function getEnvVariable (name: string): string {
  const localStorageValue = global.localStorage
    ? global.localStorage.getItem(name)
    : ''
  if (localStorageValue) {
    return localStorageValue
  }
  switch (name) {
    case 'ATHENA_ENDPOINT':
      return process.env.ATHENA_ENDPOINT || ''
    case 'HADES_CLIENT_ID':
      return process.env.HADES_CLIENT_ID || ''
    case 'HADES_ENDPOINT':
      return process.env.HADES_ENDPOINT || ''
  }
  return ''
}
